import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const LoadingSpinner = ({ size = 'medium', className = '' }: LoadingSpinnerProps) => {
  return (
    <div className={`loading-spinner loading-spinner--${size} ${className}`} role="status" aria-label="Loading">
      <div className="loading-spinner__circle"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
